import React from "react";
import "../style.css";
import { Text, View, Flex } from "@adobe/react-spectrum";
import { NoNotesIcon } from "../common/Icons";

const MyNotesDefaultPage: React.FC = () => {
  return (
    <View 
      UNSAFE_className="no-chat-wrapper mynotes-default-page"
      UNSAFE_style={{ backgroundColor: "#ffffff" }}
    >
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
        direction={"column"}
        height={"100%"}
      >
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          UNSAFE_className="no-chat-icon"
        >
          <NoNotesIcon />
        </Flex>
        <Flex justifyContent={"center"} UNSAFE_className="no-chat-heading">
          <Text>No notes</Text>
        </Flex>
        <Flex
          justifyContent={"center"}
          UNSAFE_className="no-notes-description"
          marginTop={8}
          direction="column"
          alignItems="center"
        >
          <Text>There are no notes at this time.</Text>
          <Text>You can create a new note by clicking the "Add new" button.</Text>
        </Flex>
      </Flex>
    </View>
  );
};

export default MyNotesDefaultPage;
